import React from "react";
import http from "../../util/api";
import qs from "qs";
import { getItem, setItem } from "../../util/util";

let timer;
class VertifyForLive extends React.Component {
  state = {
    name: "",
    sec: 5,
    hasSent: false,
    phone: "",
    otp: "",
    nickname: "",
    illness: { name: "点击选择病种", id: "error" },
    showIllness: false,
    illnessPool: [{ name: "", id: "" }],
    showType: false,
    TypePool: ["患者", "医生"],
    openid: "",
    loginMsg: null,
  };
  async componentDidMount() {
    document.title = "";
    const search = document.location.search;
    const querystring = search.substring(1);
    let room = qs.parse(querystring).room; //从url中取room
    let loginMsg = getItem("loginMsg") || null;
    let openid = qs.parse(querystring).openid; //从url中取unionid
    if (openid && openid !== "undefined") {
      this.getToken(room,openid);
    } else {
      const search = document.location.search;
        return (document.location.href = `${window.authBaseUrl}${window.returnUrl}VertifyForLive${search}`);
        
    }

  }
  getToken = async (room,openid) => {
    let res;
    let url = { baseURL: window.liveUrl };
    try {
      res = await http(url).login({
        code: "public",
        password: "123456",
      });
      this.setState({ name: room });
      let str = JSON.stringify(res.data);
      localStorage.setItem("userInfo", str);
      let res2 = await http(url).getTable({
        resid: "636057774086",
        cmswhere :`openid = '${openid}'`
      });
      let arr = [
        {
          _id: 1,
          _state: "added",
          C3_641473978690: room,
          C3_641473639851: "0000",
          doctor_hospital:'医生',
          C3_641473640122:res2.data.data[0].C3_663685849381,
          username:res2.data.data[0].patient_name
        }
      ]
      this.login(arr)
    } catch (e) {
    }
  };
  login = async (arr) => {
              let res;
              let url = { baseURL: window.liveUrl };
              let str = "";
              str = JSON.stringify(arr);
              try {
                res = await http(url).saveLive({
                  resid: "641473602835",
                  data: str,
                });
                setItem("loginMsg", str);
                console.log(res.data.data[0].redirecturl)
                window.location.href = res.data.data[0].redirecturl;
              } catch (e) {
                console.log(e.message);
              }
            
          
  };

  render() {
    const { showType, TypePool, currentType } = this.state;
    return (
      <div>
        
      </div>
    );
  }
}

export default VertifyForLive;
